import { useCallback } from 'react';
import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import { translate } from '@fiverr-private/i18n-react';
import { useLandingPage } from '../context/LandingPageContext';

export const useSendMessage = () => {
    const { userId } = getContext();
    const { platform, briefBoxInputValue } = useLandingPage();

    const sendMessage = useCallback(
        async ({ sellerUsername }: { sellerUsername: string }) => {
            if (userId) {
                try {
                    const url = pathfinder('message_create');
                    const payload = {
                        participants_usernames: [sellerUsername],
                        content_type: 'text',
                        content_blocks: [
                            {
                                type: 'text',
                                plain_text: `${translate('vibe_coding_perseus.seller_message.message_prefix', {
                                    params: { platform },
                                })}\n\n${briefBoxInputValue}`,
                            },
                        ],
                    };
                    const response = await axios.post(url, { ...payload });

                    return response.data;
                } catch (error) {
                    logger.error(error as Error, {
                        description: `Failed to send message to ${sellerUsername}`,
                    });
                    throw error;
                }
            } else {
                throw new Error('User is not logged in');
            }
        },
        [userId, platform, briefBoxInputValue]
    );

    return {
        sendMessage,
    };
};
